import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import FlagList from './FlagList';

/**
 * The `FlagsPage` component shows the flags list. It is only
 * used on mobile devices where the flags dropdown is within the drawer.
 */
export default class FlagsPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    app.history.push('flags');
    app.flags.load();
    this.bodyClass = 'App--flags';
  }
  view() {
    return m("div", {
      className: "FlagsPage"
    }, m(FlagList, {
      state: app.flags
    }));
  }
}
flarum.reg.add('flarum-flags', 'forum/components/FlagsPage', FlagsPage);